<template lang="pug">
  .row-flex.-layout(ref="popup")
    .col-xs-9.-layout-left(ref="scrollWrap", @scroll="$emit('leftScroll', $event)")
      slot(name="left")
    .col-xs-3.-layout-right
      slot(name="right")
    slot(name="bottom")
</template>

<script>

export default {
  name: 'AppLayout'
}
</script>

<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
.-layout {
  background-color: #fafafa;

  .-layout-left, .-layout-right {
    overflow-y: auto;
  }
  .-layout-left {
    padding: 15px 30px;
    border-right: 1px solid #ddd;
    background-color: #fff;
  }
  .-layout-right {
    margin-left: -1px;
    padding: 15px;
    border-left: 1px solid #ddd;

    h5 {
      font-weight: bold;
    }

    .-widget {
      margin-bottom: 30px;
    }
  }
}
// xs, smサイズでは1列で縦長に表示する
@media (max-width: $screen-sm-max) {
  .-layout-left, .-layout-right {
    height: auto;
    max-height: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/AppLayout.vue